
import { enableProdMode, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgSelectModule } from '@ng-select/ng-select';
import { JwtModule } from '@auth0/angular-jwt';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { TitleCasePipe, SlicePipe, CurrencyPipe, DatePipe } from '@angular/common';

import { AppComponent } from './app/app.component';
import { environment } from '@env/environment';
import { register } from 'swiper/element/bundle';
import { appRoutes } from './app/app.routing';
import { MapfreDesignLibraryModule } from './app/modules/mapfre-design-library/src/public_api';

// Services / interceptors
import { AuthGuard } from './app/_guards/auth.guard';
import { SignUpGuard } from './app/_guards/signup.guard';
import { AchGuestPaymentGuard } from './app/_guards/ach-guest-payment.guard';
import { ChangeProfileSettingsPasswordGuard } from './app/_guards/change-profile-settings-password.guard';
import { ChangeProfileSettingsEmailGuard } from './app/_guards/change-profile-settings-email.guard';
import { JwtInterceptor } from './app/_helpers/jwt.interceptor';
import { ErrorInterceptionService } from './app/_services/error-service/error-interception.service';
import { AuthenticationService } from './app/_services/_iam/authentication-service.service';
import { UserService } from './app/_services/user.service';
import { WalletCardService } from './app/_services/_iam/wallet-card.service';
import { ProfileSettingsRoutingService } from './app/_services/profile-settings/profile-settings-routing.service';
import { ProfileConfirmModalService } from './app/_services/profile-settings/profile-confirm-modal.service';
import { UnenrollmentConfirmModalService } from './app/_services/profile-settings/unenrollment-confirm-modal.service';
import { PolicyDetailsService } from './app/_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from './app/_services/storage-service-observables/storage-service-observables.service';
import { PolicyDataService } from './app/_services/my-insurance/data-services/policy-data.service';
import { PolicyDocumentsDataService } from './app/_services/my-insurance/data-services/policy-documents-data.service';
import { AddressService } from './app/_services/change-address/validate-address.service';
import { MobileOtpService } from './app/_services/mobile-otp/mobile-otp.service';
import { FooterPositionService } from './app/_services/footer-position-service/footer-position.service';
import { SortPipe } from './app/_helpers/_pipes/sort.pipe';
import { appInitializerFactory } from './app/app.initializer';
import { OktaAuthService } from './app/_services/_iam/okta-auth.service';
import { oktaAuth } from './app/_helpers/okta.config';

register();

export function tokenGetter() {
  return localStorage.getItem('currentUser');
}

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        DragDropModule,
        NgSelectModule,
        MatSlideToggleModule,
        TranslateModule.forRoot(),
        MapfreDesignLibraryModule.forRoot(),
        OktaAuthModule,
        JwtModule.forRoot({ config: { tokenGetter } }),
        RouterModule.forRoot(appRoutes, {
          anchorScrolling: 'enabled',
          scrollPositionRestoration: 'enabled',
          scrollOffset: [0, 80]
        }),
      ),
      {
        provide: APP_INITIALIZER,
        useFactory: appInitializerFactory,
        deps: [OktaAuthService],
        multi: true,
      },
      { provide: OKTA_CONFIG, useValue: { oktaAuth } },
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptionService, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      AuthGuard,
      SignUpGuard,
      AchGuestPaymentGuard,
      ChangeProfileSettingsPasswordGuard,
      ChangeProfileSettingsEmailGuard,
      AuthenticationService,
      UserService,
      WalletCardService,
      ProfileSettingsRoutingService,
      ProfileConfirmModalService,
      UnenrollmentConfirmModalService,
      PolicyDetailsService,
      StorageServiceObservablesService,
      PolicyDataService,
      PolicyDocumentsDataService,
      AddressService,
      MobileOtpService,
      FooterPositionService,
      SortPipe,
      TitleCasePipe,
      SlicePipe,
      CurrencyPipe,
      DatePipe,
    ],
  }).catch((err) => console.log(err));
});
